<template>
    <div style="height: 100%;">
        <b-navbar  toggleable="sm" type="dark"  variant="primary primaryGColor shadow">
            <b-navbar-brand to="/" class="d-none d-sm-block">姓名DNA</b-navbar-brand>

        </b-navbar>

        <b-form v-if="show" class="mx-auto w-75 pt-3">
            <h3 class="text-center mt-5">註冊會員帳號</h3>
            <p class="text-center mb-5">姓名分析專家</p>
            <p class="text-center text-primary">請選擇以下方式註冊</p>
            <b-overlay
                    :show="Lineloginloading"
                    rounded
                    opacity="0.6"
                    spinner-small
                    spinner-variant="light"
                    class=" mt-3"

            >
                <b-button block variant="success" class="mb-3" @click="linelogin">使用LINE註冊</b-button>
            </b-overlay>
            <hr>

            <b-button block variant="primary" class="mb-3" @click="NormalRegister">使用一般帳號註冊</b-button>


        </b-form>

    </div>
</template>

<script>
export default {
  name: 'RegisterHome',
  components: {},
  data () {
    return {
      show:false,
      Lineloginloading:false,
      NormalRegisterloading:false,
      res:''

    }
  },
  computed: {},
  mounted () {
    this.$store.dispatch('actionGetCheckInvitecode', {
      phone:this.$route.params.id
    }).then((res) => {
      this.show = true

    }).catch((res)=>{

      this.show = false
      this.$router.push('/home');
    })


  },
  methods: {
    linelogin(){

      this.Lineloginloading = true
      this.$store.dispatch('actionLineAuth', {
        SalesInviteCode:this.$route.params.id
      }).then((res) => {
        this.Lineloginloading = false
        window.location.href = res.data;
      })

    },
    NormalRegister(){
      this.$router.push('/Register/'+this.$route.params.id);
    }
  }
}
</script>
